<template>
    <div
        v-if="active && alert"
        :data-theme="colorTheme"
        :data-mode="mode"
        class="surface-primary border-neutral-subtle fixed inset-x-0 bottom-0 z-50 flex items-center border-t py-3 pr-16 pl-8"
    >
        <div
            class="font-ux text-neutral-base leading-base flex w-full items-start text-base font-semibold"
            :class="{
                'justify-center': alert.alertBar_Alignment === 'centred',
                'justify-start': alert.alertBar_Alignment === 'left',
            }"
        >
            <DIcon
                v-if="alertItem.alertBarItem_Icon?.name"
                :icon="iconName(alertItem.alertBarItem_Icon)"
                class="shape-brand-accent mr-3"
            />

            <p>
                {{ alertItem.alertBarItem_Text }}

                <NuxtLink
                    v-if="alertLink?.url"
                    :to="alertLink.url"
                    :target="alertLink.target"
                    class="ml-1 inline underline underline-offset-4"
                >
                    {{ alertLink.text }}
                </NuxtLink>
            </p>
        </div>

        <div class="absolute inset-y-0 right-0 flex items-center pr-6">
            <DButton
                theme="transparent"
                icon="ph:x"
                @click="dismiss"
            />
        </div>
    </div>
</template>

<script setup>
    import { DButton, DIcon } from '@digistorm/spark'

    const { iconName } = useIcons()

    const { globalSets, getGlobalTheme } = storeToRefs(useGlobalStore())

    const active = ref(false)

    const alert = computed(() => {
        return find(globalSets.value, { name: 'Alert bar' })
    })

    const colorTheme = computed(() => {
        const alertTheme = get(alert.value, 'alertBar_ColorTheme')

        if (!isEmpty(alertTheme)) {
            return alertTheme
        }

        return getGlobalTheme.value
    })

    const alertItem = computed(() => {
        return get(alert.value, 'alertBar_Items.0', {})
    })

    const alertRead = useCookie(`alert:${alertItem.value.canonicalUid}`)

    const alertLink = computed(() => {
        return get(alertItem.value, 'alertBarItem_Link.0', {})
    })

    const dismiss = () => {
        alertRead.value = true
        active.value = false
    }

    const mode = computed(() => {
        switch (alert.value?.alertBar_ColorPalette) {
            case 'color-subtle':
                return 'brand'
            case 'color-invert':
                return 'brand-invert'
            default:
                return alert.value?.alertBar_ColorPalette
        }
    })

    onMounted(() => {
        if (alertItem.value.canonicalUid && !alertRead.value) {
            active.value = true
        }
    })
</script>
